import api from './apiConfig';

// Health check
export const getReportHealthCheck = async () => {
  try {
    const response = await api.get('/frontsite-api/v1/learner/report');
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Get Dashboard Init (learner stats & progress)
export const getDashboardInit = async () => {
  try {
    const response = await api.get('/frontsite-api/v1/learner/dashboard/init');
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Get learner report (dashboard report with stats)
export const getLearnerReport = async () => {
  try {
    const response = await api.get('/frontsite-api/v1/learner/dashboard/report');
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Get all learners report (for management)
export const getAllLearnersReport = async (filters = {}) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const url = `/reports/learners${queryParams ? `?${queryParams}` : ''}`;
    const response = await api.get(url);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Get course report
export const getCourseReport = async (courseId, filters = {}) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const url = `/reports/course/${courseId}${queryParams ? `?${queryParams}` : ''}`;
    const response = await api.get(url);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Get practice report
export const getPracticeReport = async (filters = {}) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const url = `/reports/practice${queryParams ? `?${queryParams}` : ''}`;
    const response = await api.get(url);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Export report as PDF
export const exportReportPDF = async (reportType, reportId) => {
  try {
    const response = await api.get(`/reports/export/${reportType}/${reportId}/pdf`, {
      responseType: 'blob',
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Export report as Excel
export const exportReportExcel = async (reportType, reportId) => {
  try {
    const response = await api.get(`/reports/export/${reportType}/${reportId}/excel`, {
      responseType: 'blob',
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Report note
export const reportNote = async (noteId, reason) => {
  try {
    const response = await api.post('/frontsite-api/v1/learner/note-report/report-note', {
      data: {
        'note-id': noteId,
        reason,
      },
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Report vocab drill
export const reportVocabDrill = async (drillId, soalId) => {
  try {
    const response = await api.post('/frontsite-api/v1/learner/vocab-drill-report/report', {
      data: {
        'drill-id': drillId,
        'soal-id': soalId,
      },
    });
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

// Report soal
export const reportSoal = async (type, prosetId, soalId = null) => {
  try {
    const payload = {
      data: {
        type,
        'proset-id': prosetId,
      },
    };
    
    if (soalId) {
      payload.data['soal-id'] = soalId;
    }
    
    const response = await api.post('/frontsite-api/v1/learner/report/report-soal', payload);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
    };
  }
};

